import {z} from '@hono/zod-openapi';

import {advertisingPlatformCodeSchema} from './AdvertisingCommonSchemas';
import {advertisingPreflightIssueSchema} from './AdvertisingPreflightIssueSchema';

export const advertisingPreflightResponseSchema = z
  .object({
    results: z.array(
      z.object({
        platformCode: advertisingPlatformCodeSchema,
        status: z.enum(['ready', 'blocked']),
        issues: z.array(advertisingPreflightIssueSchema),
      })
    ),
  })
  .openapi('AdvertisingPreflightResponse');

export type AdvertisingPreflightResponse = z.infer<typeof advertisingPreflightResponseSchema>;
